import React, {memo, useRef} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AppSpinner from './AppSpinner';
import { Tooltip } from 'react-tooltip';
import SingleGraph from './SingleGraph'
import '../styles/GraphContainer.css';

//export function GraphContainer(props){
const GraphContainer = (props) => {
    //console.log(props)
    /***
     *     __  ___      ___  ___  __  
     *    /__`  |   /\   |  |__  /__` 
     *    .__/  |  /~~\  |  |___ .__/ 
     *                                
     */

    const [configMenuStatus, setConfigMenuStatus] = React.useState(false); 
    // Use lifted state from parent (Content.jsx)
    const { drawnGraphs, setDrawnGraphs } = props;
    const [isLoaded, setIsLoaded] = React.useState(false);                                       // Indikator ob Daten geladen wurden.       
    const [hasError, setHasError] = React.useState(false);                                       // Indikator ob Fehler vorliegen
    const [showPrioFlags] = React.useState(true)                              // Indikator ob die Priostörungs Flags auf den Graphen mit angezeigt werden sollen (fixed default)
    const [showDeploymentFlags] = React.useState(true)                  // Indikator ob die Deployment Flags auf den Graphen mit angezeigt werden sollen (fixed default)
    // Global aktiver Info-Button (nur der Detailinfo-Button) über alle Graph-Instanzen
    const [activeInfoGraph, setActiveInfoGraph] = React.useState(null); // graphKey (productID|testID)

    /***
     *          __   ___     ___  ___  ___  ___  __  ___  __  
     *    |  | /__` |__     |__  |__  |__  |__  /  `  |  /__` 
     *    \__/ .__/ |___    |___ |    |    |___ \__,  |  .__/ 
     *                                                        
     */
    
    React.useEffect(() => {
       //console.log("Use Effect is called")
        try{
            // Prüfen ob der Graph bereits vorhanden ist
            props.visibleGraphs.forEach(function(element) {   
                
                const visibleGraphsIndex = drawnGraphs.findIndex((searchedItem) => searchedItem.testID === element.testID);
    
                if(visibleGraphsIndex === -1){
                    //console.log("Add Graph from test: " + element.testID + " Product: " + element.productID + " ProductName: " + element.productName + " TestName: " + element.displayName)
                    
                    const newGraph = {
                        testID: element.testID,
                        productID: element.productID,
                        productName: element.productName,
                        testName: element.displayName,
                        origin: element.origin,
                        url: element.url,
                        thresholds: element.thresholds,
                        avgDuration: element.avgDuration,
                        countOk: element.countOk,
                        owner: element.owner
                    };
    
                    setDrawnGraphs(prev => [...prev, newGraph])
                    
                    //props.handleNotify({type: 'success', message: "Graph hinzugefügt"})  
                }
            }) 

            // Prüfen ob Graphen entfernt wurden
            drawnGraphs.forEach(function(element) {
                
                const toDeleteIndex = props.visibleGraphs.findIndex((searchedItem) => searchedItem.testID === element.testID);
                if(toDeleteIndex === -1){
                                        setDrawnGraphs(oldValues => oldValues.filter(obj => obj.testID !== element.testID))
                }
            })
            props.syncOptionsArray(props.id, "none")
            setIsLoaded(true)    
        }
        catch (error){
            setHasError(true)
            props.handleNotify({type: 'alert', message: error})     
        }
        
    // Dependencies include visibleGraphs and drawnGraphs for sync; suppress exhaustive-deps warning intentionally
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.visibleGraphs, drawnGraphs]);    
    
    /***
     *     ___            __  ___    __        __  
     *    |__  |  | |\ | /  `  |  | /  \ |\ | /__` 
     *    |    \__/ | \| \__,  |  | \__/ | \| .__/ 
     *                                             
     */

    const toggleConfigMenuStatus = () => {
        setConfigMenuStatus(!configMenuStatus)
        //props.syncOptionsArray(props.id, "none")
    }

    // (Option toggles currently unused in UI; retained for future config expansion.)
    // Removed unused functions to satisfy linter.
    
    const checkboxRef = useRef(null)

    const gatherOptions = (timerange) => {
        
        let timerangeValue;

        if(timerange !== undefined){
            timerangeValue = timerange
            refreshAllGraphs();
        } else {
            timerangeValue = props.handleGraphDefaultTimerange
        }
        
        const options = {
            replaceGraph: checkboxRef.current.checked,
            timerange: timerangeValue
        }

        props.handleChangeGraphOptions(options);
    }

    const refreshAllGraphs = () => {
    const previousDrawnGraph = drawnGraphs;
    setDrawnGraphs([])
        setIsLoaded(false)
        setTimeout(() => {
            setIsLoaded(true)
            setDrawnGraphs(previousDrawnGraph)
          }, 200);
        
    }

    /***********************************************************************************
     * DOM für das Konfigurationsmenü generieren 
     ***********************************************************************************/
    const FillConfigMenu = () => {
        const timeranges = [
            { key: '6h',  label: '6 Stunden' },
            { key: '12h', label: '12 Stunden' },
            { key: '1d',  label: '1 Tag' },
            { key: '1w',  label: '1 Woche' },
            { key: '3w',  label: '3 Wochen' },
            { key: 'all', label: 'Gesamt' },
        ];
        const activeRange = props.handleGraphDefaultTimerange || '6h';

        return(
        <>
            <div className="productWidget--configMenuWrap productWidgetConfig--Card">
                <div className="productWidget--HeaderWrap drag-handle productWidgetConfig--Header">
                    <div className="productWidgetConfig--HeaderTextWrap">
                        <span className="productWidgetConfig--HeaderMeta">PERFORMANCEGRAPHEN</span>
                        <span className="productWidgetConfig--HeaderTitle">Widget-Konfiguration</span>
                    </div>
                    <button
                        type="button"
                        className="graphContainer--MenuBtn productWidgetConfig--CloseBtn"
                        onClick={() => toggleConfigMenuStatus()}
                        aria-label="Konfiguration schließen"
                        title="Schließen"
                    >
                        <FontAwesomeIcon icon="fa-solid fa-xmark" />
                    </button>
                </div>
                <div className="graphContainerConfig--ContentWrap productWidgetConfig--Body">
                    <section className="productWidgetConfig--Section">
                        <div className="productWidgetConfig--SectionHead">
                            <div className="productWidgetConfig--SectionIcon" aria-hidden="true">
                                <FontAwesomeIcon icon="fa-solid fa-sliders" />
                            </div>
                            <div className="productWidgetConfig--SectionTitle">Anzeige</div>
                        </div>
                        <div className="productWidgetConfig--OptionList">
                            <label className="productWidgetConfig--OptionRow">
                                <span className="productWidgetConfig--OptionLabel">Immer nur einen Graph anzeigen</span>
                                <span className="switch productWidgetConfig--OptionSwitch">
                                    <input
                                        type="checkbox"
                                        ref={checkboxRef}
                                        onChange={() => gatherOptions()}
                                        checked={!!props.replaceGraph}
                                    />
                                    <span className="slider round"></span>
                                </span>
                            </label>
                        </div>
                    </section>

                    <section className="productWidgetConfig--Section">
                        <div className="productWidgetConfig--SectionHead">
                            <div className="productWidgetConfig--SectionIcon" aria-hidden="true">
                                <FontAwesomeIcon icon="fa-solid fa-clock" />
                            </div>
                            <div className="productWidgetConfig--SectionTitle">Default-Zeitraum</div>
                        </div>
                        <div className="productWidgetConfig--SectionSubtitle">
                            Welcher Zeitraum wird für neu geladene Graphen initial verwendet?
                        </div>
                        <div className="productWidgetConfig--Segmented" role="group" aria-label="Zeitraum auswählen">
                            {timeranges.map(tr => (
                                <button
                                    key={tr.key}
                                    type="button"
                                    className={"productWidgetConfig--SegmentedBtn" + (activeRange === tr.key ? " productWidgetConfig--SegmentedBtn--Active" : "")}
                                    onClick={() => gatherOptions(tr.key)}
                                    aria-pressed={activeRange === tr.key}
                                >
                                    {tr.label}
                                </button>
                            ))}
                        </div>
                    </section>

                    <div className="productWidgetConfig--Note">
                        <FontAwesomeIcon icon="fa-solid fa-circle-info" />
                        <span>Änderungen werden erst mit dem nächsten Dashboard-Speichern dauerhaft übernommen.</span>
                    </div>
                </div>

                <div className="graphContainerConfig--DeleteWrap productWidgetConfig--Footer">
                    <button
                        type="button"
                        className="productWidgetHeader--DeleteBtn productWidgetConfig--DeleteBtn"
                        onClick={() => props.handleDelete(props.id)}
                    >
                        <FontAwesomeIcon icon="fa-solid fa-trash" />
                        <span>Widget entfernen</span>
                    </button>
                </div>
            </div>
        </>
        )}  
    


    /***
     *     __   __            __   ___ ___       __       
     *    |  \ /  \  |\/|    |__) |__   |  |  | |__) |\ | 
     *    |__/ \__/  |  |    |  \ |___  |  \__/ |  \ | \| 
     *                                                    
     */
    return(
        <>
            {configMenuStatus ?  <FillConfigMenu /> : null}
            <div className="productWidget--HeaderWrap drag-handle">
                <div className="productWidgetHeader--Title">Performancegraphen</div>
                <button
                    id={"tooltip-deleteAll"}
                    className="graphContainer--DeleteAllBtn"
                    onClick={() => props.handleDeleteAllGraphs()}
                >
                    <FontAwesomeIcon icon="fa-solid fa-trash" />
                </button>
                <Tooltip    
                    className="tooltipStyles"
                    anchorSelect={"#tooltip-deleteAll"} 
                    content={"Alle Graphen entfernen"} 
                    place="bottom" 
                    style={{ backgroundColor: "var(--hover-color)", color: "var(--text-color)", zIndex: "500" }}
                />
                <button
                    id={"tooltip-refreshAll"}
                    className="graphContainer--RefreshAllBtn"
                    onClick={() => refreshAllGraphs()}
                >
                    <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                </button>
                <Tooltip    
                    className="tooltipStyles"
                    anchorSelect={"#tooltip-refreshAll"} 
                    content={"Alle Graphen neu laden"} 
                    place="bottom" 
                    style={{ backgroundColor: "var(--hover-color)", color: "var(--text-color)", zIndex: "500" }}
                />                
                <button
                    className="graphContainer--MenuBtn"
                    onClick={() => toggleConfigMenuStatus()}
                >
                    <FontAwesomeIcon icon="fa-solid fa-ellipsis-vertical" />
                </button>
            </div>
            <div className="productWidget--ContentWrap">
            {
                (() => {
                    if (isLoaded === false)
                        return(
                            <div className="productWidget--LoadingWrap">
                                <p className="productWidget--LoadingWrapText">Lade Daten</p>
                                <p><AppSpinner /></p>
                            </div> 
                        )
                    if (hasError === true)
                        return <div className="productWidget--ErrorWrap">Error</div>
                    if (drawnGraphs.length <= 0){
                        return <div className="productWidget--ErrorWrap">Zur Anzeige einen Test in der Produktübersicht auswählen</div>
                    } else 
                        return(
                            drawnGraphs.map(originElement =>(
                                <SingleGraph 
                                    key={originElement.testID}
                                    testID={originElement.testID}
                                    productName={originElement.productName}
                                    testName={originElement.testName}
                                    productID={originElement.productID}
                                    origin={originElement.origin}
                                    url={originElement.url}
                                    handleDeleteGraph={props.handleDeleteGraph}
                                    handleToggleSynmonAnalyse={props.handleToggleSynmonAnalyse}
                                    handleNotify={props.handleNotify}
                                    thresholds={originElement.thresholds}
                                    showPrioFlags={showPrioFlags}
                                    showDeploymentFlags={showDeploymentFlags}
                                    receiveIDToken={props.receiveIDToken}
                                    handleGraphDefaultTimerange={props.handleGraphDefaultTimerange}
                                    userName={props.userName}
                                    receiveAccessToken={props.receiveAccessToken}
                                    setSelectedGraph={props.setSelectedGraph}
                                    hasDetailWidget={props.hasDetailWidget}
                                    activeInfoGraph={activeInfoGraph}
                                    setActiveInfoGraph={setActiveInfoGraph}
                                />
                            ))                            
                        )
                })()
            }
            </div>
        </>    
    )

}

export default memo(GraphContainer) 



/*
                        <div className="graphContainerConfig--OptionWrap">
                            <div className="productWidgetConfigContent--Title">Prio Störungen einblenden: </div>
                            <div className="productWidgetConfigContent--Checkbox">
                                <label className="switch productWidgetConfigContent--Switch">
                                    <input type="checkbox" onChange={() => toggleShowPrioFlags()} checked={showPrioFlags ? "checked" : ""}></input>
                                    <span className="slider round"></span>
                                </label> 
                            </div>
                        </div>
                        <div className="graphContainerConfig--OptionWrap">
                            <div className="productWidgetConfigContent--Title">Deplyment Infos einblenden: </div>
                            <div className="productWidgetConfigContent--Checkbox">
                                <label className="switch productWidgetConfigContent--Switch">
                                    <input type="checkbox" onChange={() => toggleShowDeploymentFlags()} checked={showDeploymentFlags ? "checked" : ""}></input>
                                    <span className="slider round"></span>
                                </label> 
                            </div>
                        </div>
*/